<template>
  <div class="student-task-of">
    <field v-model="valueName" is-link readonly label="名字" placeholder="选择名字" @click="showPicker = true" />
    <popup v-model="showPicker" round position="bottom">
      <picker :columns="studentList" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" />
    </popup>
    <field v-model="dateTime" is-link readonly label="时间" placeholder="选择时间" @click="showPicker2 = true" />
    <popup v-model="showPicker2" round position="bottom">
      <DatetimePicker v-model="dateTime" type="date" title="时间" :columns-order="['year', 'month', 'day']"
        :formatter="formatter" @cancel="showPicker2 = false" @confirm="onConfirmTime" :min-date="minDate"
        :max-date="maxDate" />
    </popup>
    <field v-model="valueType" is-link readonly label="请假类型" placeholder="请假类型" @click="showPicker3 = true" />
    <popup v-model="showPicker3" round position="bottom">
      <picker :columns="typelist" show-toolbar @cancel="showPicker3 = false" @confirm="onConfirmType" />
    </popup>
    <textarea-box v-model="textarea" :title="'原因'" placeholder="请填写请假原因" class="textarea-box" />
    <div class="btn" @click="sendData"> 提&nbsp;&nbsp;交 </div>
  </div>
</template>

<script>
import { getUserStudent, addStudentLeave } from '@api/user'
import { Picker, Field, Popup, DatetimePicker } from "vant";
import { addZoo } from '@common'

import TextareaBox from '@components/common/textBox/textareaBox/TextareaBox'
export default {
  name: 'StudentTaskOf',
  components: {
    Picker,
    Field,
    Popup,
    DatetimePicker,
    TextareaBox,
  },
  data() {
    return {
      studentList: [],
      typelist: ['事假', '病假', '其他'],
      uidList: [],
      textarea: '',
      showPicker: false,
      showPicker2: false,
      showPicker3: false,
      valueName: '',
      dateTime: '',
      valueType: '',
      minDate: new Date(),
      maxDate: new Date(2025, 12, 31),
      currIndex: 0
    }
  },
  created() {
    getUserStudent(this.$route.params.uid).then(res => {
      let resList = res.data.student;
      for (let item of resList) {
        this.studentList.push(item.name);
        this.uidList.push(item.user_id);
      }
    })
  },
  methods: {
    onConfirm(value, index) {
      this.valueName = value;
      this.currIndex = index;
      this.showPicker = false;
    },
    onConfirmType(value) {
      this.valueType = value;
      this.showPicker3 = false;
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
    onConfirmTime(value) {
      this.showPicker2 = false;
      let d = new Date(value);
      this.dateTime = d.getFullYear() + "-" + addZoo(d.getMonth() + 1) + '-' + addZoo(d.getDate());
    },
    /**
     * 添加请假
     */
    sendData() {
      if (this.studentList.length) {
        if (!this.valueName) {
          this.$Message.success('请填写名字');
        } else if (!this.dateTime) {
          this.$Message.success('请填写请假时间');
        } else if (!this.valueType) {
          this.$Message.success('请填写请假类型');
        } else {
          let data = {
            name: this.valueName,
            date: this.dateTime,
            type: this.valueType,
            uid: this.uidList[this.currIndex],
            textarea: this.textarea
          }
          addStudentLeave(data).then(res => {
            if (res.status === 200) {
              this.$Message.success('添加成功');
              this.valueName = '';
              this.dateTime = '';
              this.valueType = '';
              this.textarea = '';
              setTimeout(() => {
                this.$router.go(-1)
              }, 500);
            } else {
              this.$Message.success('添加失败');
            }
          }).catch(() => {
            this.$Message.success('添加失败');
          })
        }
      }
    }
  },
  watch: {
    dateTime: {
      handler(newVal) {
        if (newVal) {
          let d = new Date(newVal);
          this.dateTime = d.getFullYear() + "-" + addZoo(d.getMonth() + 1) + '-' + addZoo(d.getDate());
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.student-task-of {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: white;
}

.textarea-box {
  box-shadow: 0 0 2px 1px #f5f5f5 inset;
}

.btn {
  width: 60vw;
  height: 0.8rem;
  margin: 1rem 20vw;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #2980f7;
  color: aliceblue;
}
</style>